export default __webpack_public_path__ + "static/media/landing-2-graphic.55b2dcfb.png";